import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { HandlerPhoneEmail } from "../models/handler-phone-email.model";
import { Guid } from "guid-typescript";

@Injectable({
  providedIn: "root",
})
export class HandlerService {
  private handlerUrl = "handlers";
  private baseUrl: string;
  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiConfig.uri + this.handlerUrl;
  }

  getHandler(policyId?: Guid): Observable<HandlerPhoneEmail> {
    if (policyId) {
      const params = new HttpParams().set("policyId", policyId.toString());
      return this.http.get<HandlerPhoneEmail>(this.baseUrl + "/me", { params });
    }
    return this.http.get<HandlerPhoneEmail>(this.baseUrl + "/me");
  }
}
